/* eslint-disable no-unused-vars */
import { Grid, Typography, CircularProgress } from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";

export default function CustomergroupCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [groupCode, setGroupcode] = useState("");
  const [groupCodeError, setGroupcodeError] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showCustomergroupCrudWindow: showCustomergroupCrudWindow,
  };

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.groupName);
    }
  }, [origObject]);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && groupCode === "")
      setGroupcodeError(translate("Group code is Required"));
    else setGroupcodeError("");
  }, [groupCode]);
  /* useEffect(() => {
    if (liveValidation && description === "")
      setDescriptionError("Description is Required");
    else setDescriptionError("");
  }, [description]);*/
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showCustomergroupCrudWindow(customergroupId) {
    if (customergroupId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      setWindowTitile(translate("New Customer Group"));
    } else {
      setMode(
        props.context.privileges.customer_group_edit ||
          props.context.privileges.customer_group_delete
          ? "edit"
          : "view"
      );
      populateCustomergroup(customergroupId);
    }
  }
  async function populateCustomergroup(id) {
    {
      try {
        let { data } = await API.get("/api/v1/customergroup" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Customer group data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.groupName);
    setGroupcode(bean.groupCode);
    setDescription(bean.description);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setGroupcode("AUTO");
    setGroupcodeError("");
    setDescription("");
    setDescriptionError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }


  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message:
        translate("Are you sure to delete customer group") +
        ":" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/customergroup/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Customer group") +
          " :" +
          name +
          " " +
          translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage(
          "error",
          translate(translate("Not able to Delete Customer group"))
        );
      }
    }
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/customergroup", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        showProgress(false, "Saving");
        setOpenWindow(false);
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage(
            "error",
            translate("Not able to Save Customer group")
          );
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "groupCode") {
        setGroupcodeError(obj.message);
      }
      if (obj.field === "description") {
        setDescriptionError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["groupName"] = name;
    saveObject["groupCode"] = groupCode;
    saveObject["description"] = description;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (!groupCode || groupCode === "") {
      setGroupcodeError(translate("Group code is Required"));
      flag = false;
    }
    /* if (!description || description === "") {
      setDescriptionError("Description is Required");
      flag = false;
    }*/
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Group code")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={groupCode}
                    disabled={true}
                    error={groupCodeError}
                    onChange={(e) => setGroupcode(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Name")}</Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Description")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={description}
                    error={descriptionError}
                    onChange={(e) => setDescription(e.target.value)}
                  ></PText>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      //if (groupCode != "AUTO") return true;
      if (name || name != "") return true;
      if (description || description != "") return true;
    }
    if (mode === "edit") {
      //if (groupCode !== origObject.groupCode) return true;
      if (name !== origObject.groupName) return true;
      if (description !== origObject.description) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={
            props.context.privileges.customer_group_delete ? onDelete : false
          }
          hideSave={
            (!props.context.privileges.customer_group_edit &&
              props.context.privileges.customer_group_delete) ||
              mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
